<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <manure-storages-form
      :id="id"
      :title="title"
      :item="item"></manure-storages-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
